/**
 * en-GB messages added by Phase 3 task S21 (docs/PHASE-3-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s21EnGB = {
    'evacuation.error.remote_site': 'Remote sites have no evacuations.',
    'evacuation.error.kiosk_start_off': 'This site does not allow an evacuation to be started from a kiosk.',
    'evacuation.error.wrong_pin': 'That evacuation PIN is not right.',
    'evacuation.error.closed': 'This evacuation ended more than a day ago and no longer takes changes.',
    'evacuation.error.person_unknown': 'That person is not on this roll call.',
    'evacuation.error.still_active': 'An evacuation that is still running cannot be deleted. End it first.',
    'evacuation.note.signed_in_during': 'Signed in during the evacuation',
    'evacuation.note.member_signed_in': 'Staff member signed in during the evacuation',
    'evacuation.note.signed_out': 'Signed out at {time}',
};
//# sourceMappingURL=s21.js.map